<template>
    <div
        @click="handleClick"
        class="radio-option"
        :class="{
            selected: isSelected,
            disabled: disabled,
        }"
    >
        <div class="option-radio">
            <div class="radio-outer" :class="{ checked: isSelected }">
                <div v-if="isSelected" class="radio-inner"></div>
            </div>
        </div>

        <div class="option-content">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    isSelected: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['click'])

const handleClick = () => {
    if (!props.disabled) {
        emit('click')
    }
}
</script>

<style scoped>
.radio-option {
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    padding: 14px 10px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border: 0.5px solid rgba(104, 105, 132, 0.5);
    background: rgba(255, 255, 255, 0.02);
}

.radio-option:hover:not(.disabled) {
    border-color: #4d4d5d;
}

.radio-option.selected {
    border-color: rgb(83, 71, 219);
    background: rgba(83, 71, 219, 0.25);
}

.radio-option.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
}

.option-radio {
    margin-right: 12px;
}

.radio-outer {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid #686984;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s;
}

.radio-outer.checked {
    border-color: #5347db;
}

.radio-inner {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #5347db;
}

.option-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
}
</style>
